import { useAsideMenu, useAuth, useTheme } from "hooks"
import {
	ADMIN_GENDERS_LIST,
	AM_GENDER,
	BICYCODE_ASSO_ORDER_TAGS_URL,
	CASH_CONVERTER_ORDER_TAGS_URL,
	COLLECTIVITE_GENDER,
	EASY_CASH_ORDER_TAGS_URL,
	FAQLinks,
	GIANT_STORES_ORDER_TAGS_URL,
	HORS_AM_GENDER,
	LECLERC_ORDER_TAGS_URL,
	PRO_ORDER_TAGS_DEFAULT_URL,
	VELOCISTE_GENDER,
	YAMAHA_ORDER_TAGS_URL,
	operators,
	partnerChainList,
} from "utils/constants"

import { hasAccessToTheBikeFleet } from "utils"

import { ButtonIconLink } from "./ButtonIconLink"
import { BicytrustIcon } from "components/Elements/Icons/BicytrustIcon"
import { BikeIcon, TagIcon, FAQIcon } from "components/Elements/Icons"
import FleetIcon from "components/Elements/Icons/Fleet"
import HomeIcon from "components/Elements/Icons/HomeIcon"
import TeamManagementIcon from "components/Elements/Icons/TeamManagement"
import {
	BIKE_MANAGEMENT_ID,
	LABEL_ORDER_ID,
	BICYTRUST_CONTRACT_ID,
	FLEET_MANAGEMENT_ID,
	TEAM_MANAGEMENT_ID,
	CONTACT_SUPPORT_ID,
	MENU_BO,
} from "utils/constants/menuTypes"
import { BC_OPERATOR } from "utils/constants"
import { privateRoutes } from "router/routes"
import React from "react"
import { Operator } from "models"
import { useTranslation } from "react-i18next"

export const MenuLinks = () => {
	const { entity } = useAuth()
	const { currentTheme } = useTheme()
	const { t } = useTranslation()
	const { authorizedAccessOrderLabel, getOrderTagsUrl } = useAsideMenu()

	const entityRole = entity?.entity_data?.entity_permission?.role
	const isMANAGEBIKES = entityRole === "MANAGEBIKES"
	const isAdmin = ADMIN_GENDERS_LIST.includes(entity.gender)

	const isBCTheme = currentTheme?.id_api === BC_OPERATOR
	const isAvailableToOrderTags = isBCTheme

	const isAutorizedToAccessBikeFleetPage = hasAccessToTheBikeFleet(
		entity.data_operators,
		currentTheme.id_api
	)
	const isAuthorizedBicytrust = (entity?.entity_data?.est_bicytrust && isBCTheme) || false

	return (
		<div className="c-aside__nav">
			<ButtonIconLink
				path={privateRoutes.searchBike.path}
				id={BIKE_MANAGEMENT_ID}
				Icon={BikeIcon}
				isVisible={isMANAGEBIKES}
				label={t("menu.fnuci_register")}
				dataCy="search-bike"
			/>
			<ButtonIconLink
				id={LABEL_ORDER_ID}
				Icon={TagIcon}
				isVisible={isAvailableToOrderTags && !isAdmin}
				label={t("menu.order_tags")}
				dataCy="order-tags"
				path={
					authorizedAccessOrderLabel
						? privateRoutes.bikeLabelOrder.path
						: getOrderTagsUrl()
				}
				external={!authorizedAccessOrderLabel}
			/>
			<ButtonIconLink
				path={privateRoutes.bikeFleet.path}
				id={FLEET_MANAGEMENT_ID}
				Icon={FleetIcon}
				isVisible={isAutorizedToAccessBikeFleetPage && !isAdmin}
				label={t("bikeFleet.title", { ns: "bike" })}
				dataCy="bike-fleet"
			/>
			<ButtonIconLink
				path={privateRoutes.bicytrust.path}
				id={BICYTRUST_CONTRACT_ID}
				Icon={BicytrustIcon}
				isVisible={isAuthorizedBicytrust && !isAdmin}
				label={t("insurance.list.title", { ns: "bike" })}
				dataCy="bicytrust"
			/>
			<ButtonIconLink
				path={privateRoutes.shop.path}
				id={TEAM_MANAGEMENT_ID}
				Icon={TeamManagementIcon}
				isVisible={isMANAGEBIKES}
				label={t("menu.store")}
				dataCy="shop-store"
			/>
			<ButtonIconLink
				path={privateRoutes.contact.path}
				id={CONTACT_SUPPORT_ID}
				Icon={FAQIcon}
				isVisible={isMANAGEBIKES && !isAdmin}
				label={t("menu.contact_support")}
				dataCy="contact-support"
			/>
			<ButtonIconLink
				path={privateRoutes.validatedPartner.path}
				id={MENU_BO}
				Icon={HomeIcon}
				isVisible={isAdmin}
				label={t("menu.menu")}
				dataCy="validate-partner"
			/>
		</div>
	)
}
